import { createContext } from 'react';

import type { StratoLogger } from './sdk-logger.js';

/**
 * Context for storing Strato loggers.
 * @internal
 */
export const StratoLoggerContext = createContext<StratoLogger | undefined>(
  undefined,
);
